<div class="bp-modal">
	<div class="bp-modal-body-section text-center">
		<h2 class="mb-15">{{ "withdrawal_lock" | translate }}</h2>
		<p class="text-light mb-10">
			{{ "you_have_to_wait_REMAINING_HOURS_hour_until_withdraw" | translate: [waitingHours, remainingHours] }}
		</p>
		<button
			class="modal-add-info-button btn btn-primary btn-bold btn-bigger-text btn-widest"
			(click)="save()"
			tabindex="501">
			{{ "got_it_ack" | translate }}
		</button>
	</div>
</div>
